import * as React from 'react';
import { Input as $Input } from 'antd';
import { FieldProps, Field } from 'formik';
import { FormikFieldProps } from 'formik-antd/lib/FieldProps';
import { InputProps as $InputProps } from 'antd/lib/input';

import SecureInput from 'components/formik/SecureInput';

type OwnProps = {
  secureMode?: boolean;
};
type InputProps = FormikFieldProps & $InputProps & OwnProps;
type CustomInputComponentProps = InputProps & FieldProps;

function areEqual(
  prevProps: CustomInputComponentProps,
  nextProps: CustomInputComponentProps,
) {
  return prevProps.field.value === nextProps.field.value;
}

const CustomInputComponent = React.memo(
  ({
    field: { name, value, onChange, onBlur },
    form,
    fast,
    children,
    onChange: $onChange,
    onBlur: $onBlur,
    secureMode = false,
    ...props
  }: CustomInputComponentProps) => {
    const InputComponent = secureMode ? SecureInput : $Input;

    return (
      <InputComponent
        value={value}
        onChange={(event) => {
          onChange(event);
          $onChange && $onChange(event);
        }}
        onBlur={(event) => {
          onBlur(event);
          $onBlur && $onBlur(event);
        }}
        {...props}
        name={name}
        autoComplete="off"
      />
    );
  },
  areEqual,
);

export default function Input(props: InputProps) {
  return (
    <Field
      validate={props.validate}
      fast={props.fast}
      component={CustomInputComponent}
      {...props}
      name={props.name}
    />
  );
}
